(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["familia-tamanos"] && !Shopify.designMode) return;
  try {
    // ---------------------------------------------------------------------
  // Chips de familia: cambian el precio EN LA MISMA TARJETA, sin navegar.
  //
  // Vive en el snippet y no en cada seccion a proposito: la misma tarjeta la
  // dibujan tres secciones distintas (home, coleccion y buscador) y tener tres
  // copias del intercambio era garantia de que se fueran separando. Shopify
  // junta el bloque de javascript de todo lo que se renderiza en la pagina en un
  // solo `compiled_assets/scripts.js`, asi que esto viaja una vez.
  //
  // No conoce NINGUNA clase de NINGUNA seccion: encuentra todo por atributos
  // `data-*` (ver "El contrato con la tarjeta" arriba). Y no recalcula nada:
  // los importes ya vienen formateados por `money`, y el precio sin impuestos y
  // las cuotas ya renderizados por sus snippets. Aca solo se intercambia.
  //
  // Un solo listener delegado en `document`: da igual cuantas tarjetas haya y
  // sobrevive a `shopify:section:load` del editor sin registrar nada nuevo.
  // ---------------------------------------------------------------------
  (function () {
    if (window.__lucatmiFamiliaChips) return;
    window.__lucatmiFamiliaChips = true;

    function elegir(chip) {
      var card = chip.closest('[data-familia-card]');
      if (!card || chip.classList.contains('is-actual')) return;
      var d = chip.dataset;
      var disponible = d.disponible === '1';

      card.querySelectorAll('[data-familia-chip]').forEach(function (otro) {
        var activo = otro === chip;
        otro.classList.toggle('is-actual', activo);
        otro.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });

      var precio = card.querySelector('[data-familia-precio]');
      if (precio) precio.innerHTML = d.precio || '';

      var neto = card.querySelector('[data-familia-neto]');
      if (neto) neto.innerHTML = d.neto || '';

      var cuotas = card.querySelector('[data-familia-cuotas]');
      if (cuotas) cuotas.innerHTML = d.cuotas || '';

      // El enlace de la tarjeta y el boton de compra tienen que apuntar al
      // hermano elegido: si no, alguien elige 100 ml y compra el de 30.
      if (d.url) {
        card.querySelectorAll('[data-familia-link]').forEach(function (enlace) {
          enlace.setAttribute('href', d.url);
        });
      }

      var media = card.querySelector('[data-familia-media]');
      if (media) {
        var img = media.querySelector('img');
        if (img && d.imagen) {
          // El srcset original apunta al frasco del otro tamano.
          img.removeAttribute('srcset');
          img.setAttribute('src', d.imagen);
          if (d.alt) img.setAttribute('alt', d.alt);
        }
        var vieja = media.querySelector('[data-familia-etiqueta]');
        if (vieja && vieja.parentNode) vieja.parentNode.removeChild(vieja);
        if (d.etiqueta) media.insertAdjacentHTML('afterbegin', d.etiqueta);
      }

      card.classList.toggle('is-sold-out', !disponible);
      var boton = card.querySelector('[data-familia-boton]');
      if (boton && d.boton) boton.textContent = d.boton;
    }

    document.addEventListener('click', function (event) {
      var destino = event.target;
      if (!destino || !destino.closest) return;
      var chip = destino.closest('[data-familia-chip]');
      if (!chip) return;
      event.preventDefault();
      elegir(chip);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
